import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { translationChunksConfig, translationsEn } from '@spartacus/assets';
import { I18nConfig, OccConfig, provideConfig, provideFeatureToggles } from '@spartacus/core';
import { defaultCmsContentProviders, layoutConfig, LogoutGuard, mediaConfig } from '@spartacus/storefront';
import { environment } from 'src/environments/environment';
import { VscaLogoutGuard } from 'src/core/auth/user-auth/guards/vsca-logout.guard';

const occConfig: OccConfig = { backend: { occ: {} } };
// only provide the `occ.baseUrl` key if it is explicitly configured, otherwise the value of
// <meta name="occ-backend-base-url" > is ignored.
// This in turn breaks the deployment in CCv2.
// https://github.com/SAP/spartacus/issues/5886
occConfig.backend.occ.prefix = '/sanofiusocc/v2/';
occConfig.backend.occ.useWithCredentials = true;
if (environment.occBaseUrl) {
  occConfig.backend.occ.baseUrl = environment.occBaseUrl;
}

const PRODUCT_TYPE = 'DEFAULT';
let baseSiteId = window.location.pathname.substring(1, 4);
const cartId =
  baseSiteId === 'vax'
    ? JSON.parse(localStorage.getItem('spartacus⚿vax⚿cart'))?.active
    : JSON.parse(localStorage.getItem('spartacus⚿vsh⚿cart'))?.active;
const userId = decodeURIComponent(localStorage.getItem("user_login_id") ?? "").replace(/"/g, "");

@NgModule({
  declarations: [],
  imports: [BrowserModule],
  providers: [
    { provide: LogoutGuard, useExisting: VscaLogoutGuard },
    provideFeatureToggles({
      a11yKeyboardAccessibleZoom: false,
      a11yPreventCartItemsFormRedundantRecreation: false,
      a11yLinkBtnsToTertiaryBtns: false,
      a11yWideScreenImprovements: false,
      a11yOptimizedMenuSpacing: false,
      a11yNgSelectLayering: false,
      a11yNgSelectAriaControls: false,
      enableReadDomainValuesOnDemand: false,
      authorizationCodeFlowByDefault: false,
      incrementProcessesCountForMergeCart: false,
      dispatchLoginActionOnlyWhenTokenReceived: false,
      cdsLoginEventsToken: false
    }),
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      backend: occConfig.backend,
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',

        allowOrigin:
          '*.aventis.com:8088,*.aventis.com:443,us-d3-admin.pharma.aventis.com:80,us-d3-admin.pharma.aventis.com:8080,us-d3-admin.pharma.aventis.com:8088,us-d3-admin.pharma.aventis.com:443,us-d3-admin.pharma.aventis.com:8443,us-s2-admin.pharma.aventis.com:80,us-s2-admin.pharma.aventis.com:8080,us-s2-admin.pharma.aventis.com:8088,us-s2-admin.pharma.aventis.com:443,us-s2-admin.pharma.aventis.com:8443,us-s1-admin.pharma.aventis.com:80,us-s1-admin.pharma.aventis.com:8080,us-s1-admin.pharma.aventis.com:8088,us-s1-admin.pharma.aventis.com:443,us-s1-admin.pharma.aventis.com:8443,*.ondemand.com:80,*.ondemand.com:8080,*.ondemand.com:8088,*.ondemand.com:443,*.ondemand.com:8443,*.ondemand.com:9002,localhost:9022, api.us-s1.sanofiecomm.com:8080, api.us-s1.sanofiecomm.com:8443,api.us-s1.sanofiecomm.com:8088,*.sanofiecomm.com:8080,*.sanofiecomm.com:8443,*.sanofiecomm.com:8088,*.sanofiecomm.com:9002,*.sanofiecomm.com:443',
      },
      context: {
        urlParameters: ['baseSite', 'language', 'currency'],
        baseSite: ['vsh', 'vax'],
        currency: ['USD'],
        language: ['en'],
      },
      features: {
        level: '6.6',
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {
          en: translationsEn
        },
        chunks: translationChunksConfig,
        backend: {
          loader: (lng: string, ns: string) => import(`../../../public/i18n-assets/en/${ns}.json`),
          chunks: translationChunksConfig,
        },
      },
    }),
    provideConfig({
      backend: {
        occ: {
          endpoints: {
            asmCustomerSearch: `/sanofiusocc/v2/${baseSiteId}/assisted-service/customers/search`,
            product:
              'products/${productCode}?fields=name,baseProduct,variantOptions(description,DEFAULT),variantType,code,description,manufacturer,baseProductName,baseProductDescription,images(DEFAULT),documents(DEFAULT),resources(DEFAULT),variants(code,description,url,DEFAULT),url,purchasable,categories(name,url,DEFAULT),storageDescription,calculator,formularyProduct,flu,shipNow,fluCategories,available,unavailable,orderable,discontinued,uom,quantityPerUnit,productUnavailableForEmployee,ndcCode,innerText,callNote,yellowFever,discontinuedText,priceDisclaimer,minOrderQuantity',
            productSearch: `products/search?fields=products(${PRODUCT_TYPE},images(DEFAULT)),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery`,
            productReferences:
              'products/${productCode}/references?referenceType=CROSSELLING&locationId=',
            cart: `users/${userId}/carts?fields=DEFAULT`,
          },
        },
      },
    } as OccConfig),
  ],
})

export class SpartacusConfigurationModule {}
